import { setSpecificMessage, someItem } from "valibot";
setSpecificMessage(
  someItem,
  (issue) => `Élément invalide: reçu ${issue.received}`,
  "fr"
);